import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonCancelComponent } from '@ui-kit/buttons/button-cancel/button-cancel.component';
import { ButtonComponent } from '@ui-kit/buttons/button/button.component';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';

@Component({
    selector: 'modal',
    imports: [TranslateModule, DialogModule, DividerModule, ButtonCancelComponent, ButtonComponent, NgClass],
    templateUrl: './modal.component.html',
    styleUrl: './modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class ModalComponent {
    id = input.required<string>();
    visible = model.required<boolean>();

    title = input<string>('');

    severity = input<'' | 'success' | 'warning' | 'info' | 'danger'>('');
    size = input<'small' | 'default' | 'medium' | 'large'>('default');

    closable = input<boolean>(true);
    dismissableMask = input<boolean>(false);
    draggable = input<boolean>(false);

    includeCancelButton = input<boolean>(false);
    includeConfirmButton = input<boolean>(false);
    cancelButtonLabel = input<string>('uiKit.miscs.modal.cancelButtonLabel');
    confirmButtonLabel = input<string>('uiKit.miscs.modal.confirmButtonLabel');
    cancelButtonSeverity = input<
        'success' | 'info' | 'warn' | 'danger' | 'help' | 'primary' | 'secondary' | 'contrast'
    >('secondary');
    confirmButtonSeverity = input<
        'success' | 'info' | 'warn' | 'danger' | 'help' | 'primary' | 'secondary' | 'contrast'
    >('success');
    confirmButtonDisabled = input<boolean>(false);
    actionsLoading = input<boolean>(false);
    prepareLoading = input<boolean>(false);

    modalSize = computed(() => this.computeModalSize(this.size()));
    includeFooter = computed(() => {
        return (this.includeCancelButton() || this.includeConfirmButton()) && !this.prepareLoading();
    });
    severityIcon = computed(() => {
        switch (this.severity()) {
            case 'success':
                return 'fa-circle-check';
            case 'warning':
                return 'fa-triangle-exclamation';
            case 'info':
                return 'fa-circle-info';
            case 'danger':
                return 'fa-circle-minus';
            default:
                return '';
        }
    });

    onCancel = output<void>();
    onConfirm = output<void>();
    onHide = output<void>();

    private computeModalSize(size: 'small' | 'default' | 'medium' | 'large'): string {
        switch (size) {
            case 'small':
                return '35rem';
            case 'default':
                return '45rem';
            case 'medium':
                return '55rem';
            case 'large':
                return '65rem';
            default:
                return '45rem';
        }
    }
}
